// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtnContainer":"VbPqrS","addToCartBtn":"AlpQKX","fitWidth":"uHHCEk","stretchWidth":"nT3MTK"};